import TranslateIcon from '@mui/icons-material/Translate';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Flag emojis for languages
const FLAGS = {
  sv: '🇸🇪',
  en: '🇬🇧'
};

const LANGUAGE_NAMES = {
  sv: 'Svenska',
  en: 'English'
};

const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
    // Persist language choice
    localStorage.setItem('preferred-language', language);
    handleClose();
  };

  const currentLanguage = i18n.language || 'sv';

  return (
    <>
      <Tooltip title={t('language.select')}>
        <IconButton
          onClick={handleClick}
          size='large'
          edge='end'
          color='inherit'
          aria-label='language selector'
          sx={{ mr: 1.5, flexGrow: 0 }}
        >
          <TranslateIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {Object.entries(LANGUAGE_NAMES).map(([code, name]) => (
          <MenuItem key={code} onClick={() => handleLanguageChange(code)} selected={currentLanguage === code}>
            <ListItemIcon>
              <span style={{ fontSize: '1.2em' }}>{FLAGS[code as keyof typeof FLAGS]}</span>
            </ListItemIcon>
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
